(function ($) {

    $(function () {

        // Copy to clipboard

        function copyToClipboard(text) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text)
                    .then(() => {
                        $('.js-openShare').addClass('-toast');
                        setTimeout(() => {
                            $('.js-openShare').removeClass('-toast');
                        }, 1500);
                    })
                    .catch(err => {
                        console.error('Failed to copy: ', err);
                    });
            } else {
                // Fallback for older browsers
                fallbackCopyTextToClipboard(text);
            }
        }

        function fallbackCopyTextToClipboard(text) {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(text).select();
            document.execCommand('copy');
            $temp.remove();
        }

        $(document).on('click', '.js-copyLink', function(e) {
            const url = $(this).data('url');
            copyToClipboard(url);
        });

        // Socials share popup

        $(document).on('click', '.js-openShare', function(e) {
            $(this).addClass('-active');
            $('.js-dim').addClass('-active -share');
            $('html, body').addClass('-overflow');
        });

        // Anchor animation
        $('a[href*="#"]:not([href="#"])').click(function(e) {
            if ($.isEmptyObject($(this).data()) &&
                location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') &&
                location.hostname == this.hostname) {

                e.preventDefault();

                let target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

                let siteHeader = $('.o-header');
                let navHeight = siteHeader.height() + 95;

                let position = window.getComputedStyle(siteHeader[0]).position;
                if (position !== 'fixed' && position !== 'sticky') {
                    navHeight = 0;
                }

                if (target.length) {
                    window.scrollTo({
                        top: target.offset().top - navHeight,
                        behavior: "smooth"
                    });
                    return false;
                }
            }
        });

        $('.js-anchorScroll').on('click', function(e) {
            e.preventDefault(); // Prevent default link behavior

            console.log('click!');

            // Get target ID from data-anchor
            var targetId = $(this).data('anchor');
            var $target = $('#' + targetId);
                console.log($target);

            if ($target.length) {
                // Animate scrolling
                $('html, body').animate({
                    scrollTop: $target.offset().top - 100
                }, 1000, 'swing');
            }
        });

    });

} ) ( jQuery );